import { SearchOutlined, PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons'
import { Button, Input, Modal, Select, message } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { delExport, fetchExport, modExport } from '../../apis/export'
import MainTable from '../../components/Basic/MainTable.js'
import useParams from '../../hook/useParams.js'
import { MenuWrapper, SearchWrapper, WhiteWrapper } from './exportList.styled'
import { fetchGroupList } from '../../apis/group.js'
import ExportModal from './ExportModal.js'
import PopupConfirm from '../../components/Basic/PopupConfirm'
import { fetchBrandList } from '../../apis/brand.js'

const ExportList = props => {
  const { t: ln_t } = useTranslation()
  const params = useParams({ includes: 'mappingKey' })
  const { handleFetchParams, setReady, fetchParams } = params
  const [groupId, setGroupId] = useState()
  const [groupsOption, setGroupsOption] = useState([])
  const [brandsOption, setBrandsOption] = useState([])
  const [modalProps, setModalProps] = useState({})

  const handleAdd = () => setModalProps({ title: `${ln_t('util.add')} ${ln_t('sidebar.export')}`, open: true, data: { groupId } })

  const handleEdit = ({ information = {}, dataType = {}, ...others }) => {
    const data = { ...others, ...information, dataType: dataType.id }
    setModalProps({ title: `${ln_t('util.edit')} ${ln_t('sidebar.export')}`, open: true, data, editMode: true })
  }

  const handleDelete = ({ id, name }) => {
    Modal.confirm({
      title: `${ln_t('util.delete')} ${ln_t('sidebar.export')}`,
      content: `${ln_t('message.confirm.delete')} ${name} ?`,
      onOk: async () => {
        const result = await delExport(id)
        if (result?.status === 204) {
          message.success(ln_t('message.success.delete'))
          handleFetchParams('add', {})
        }
      }
    })
  }

  const handleChangeStatus = async (record, update) => {
    const result = await modExport(record?.id, update)
    if (result?.status === 200) {
      message.success(ln_t('message.success.modify'))
      handleFetchParams('add', {})
    }
  }

  const columns = [
    { title: ln_t('export.name'), dataIndex: 'name', sorter: true },
    { title: ln_t('export.transType'), dataIndex: 'transType', sorter: true },
    { title: ln_t('export.dataType'), dataIndex: 'mappingKey', render: e => e?.name },
    { title: ln_t('export.status'), dataIndex: 'status', sorter: true, render: (e, record) => <PopupConfirm type="status" checked={e} onConfirm={() => handleChangeStatus(record, { status: e ? 0 : 1 })} /> },
    { title: ln_t('export.createdAt'), dataIndex: 'createdAt', sorter: true, render: (time) => dayjs(time).format('YYYY-MM-DD') },
    { title: ln_t('export.updatedAt'), dataIndex: 'updatedAt', sorter: true, render: (time) => dayjs(time).format('YYYY-MM-DD') },
    {
      title: ln_t('util.action'),
      dataIndex: 'id',
      render: (id, record) => (
        <div className="action-btn">
          <Button size="small" icon={<EditOutlined />} onClick={() => handleEdit(record)}/>
          <Button size="small" icon={<DeleteOutlined />} onClick={() => handleDelete(record)} />
        </div>
      )
    }
  ]

  const apiFunc = async () => fetchExport(fetchParams)

  const getGroups = async () => {
    const result = await fetchGroupList({ maxResults: 1000, sort: '-updatedAt' })
    if (result?.status === 200) {
      setGroupsOption(result?.data?.map(i => ({ value: i?.id, label: i?.name })))
      setGroupId()
    }
  }

  const getBrands = async () => {
    const result = await fetchBrandList({ maxResults: 1000, sort: '-updatedAt' })
    if (result?.status === 200) setBrandsOption(result?.data)
  }
  useEffect(() => {
    getGroups()
    getBrands()
    handleFetchParams('init')
    setReady(true)
  }, [])

  const passProps = { ...modalProps, groupsOption, allBrands: brandsOption, setModalProps, params }
  return (
    <>
      <WhiteWrapper>
        <h3>{ln_t('sidebar.export')}</h3>
        <MenuWrapper>
          <SearchWrapper>
            <Input.Search
              style={{ width: '400px' }}
              placeholder={ln_t('util.search')}
              onSearch={e => handleFetchParams('add', { name_like: `%${e}%` })}
              enterButton={<Button type="primary" size="small" icon={<SearchOutlined />} />}
            />
          </SearchWrapper>
          <span style={{ fontSize: '14px', fontWeight: 500, margin: '0 8px 0 16px' }}>
            {ln_t('util.group')} :
          </span>
          <Select
            showSearch
            style={{ minWidth: '120px' }}
            defaultValue="all"
            placeholder={`${ln_t('util.select')} ${ln_t('util.group')}`}
            options={[{ value: 'all', label: 'ALL' }, ...groupsOption]}
            optionFilterProp="children"
            value={groupId || 'all'}
            onChange={e => setGroupId(e === 'all' ? undefined : e)}
          />
          <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd} style={{ marginLeft: 'auto' }}>
            {ln_t('util.add')} {ln_t('sidebar.export')}
          </Button>
        </MenuWrapper>
        <MainTable
            className="export-list"
            tableName="export"
            columns={columns}
            rowKey="id"
            apiFunc={apiFunc}
            params={params}
            {...props}
        />
      </WhiteWrapper>

      <ExportModal {...passProps} />
    </>
  )
}

export default ExportList
